import * as client from "../ClientConsumer";
import {
    ReportClassType,
    ReportPayload,
    ReportReason,
} from "./ReportService.types";
import { PostCommentsInfo } from "./PostCommentsService.types";

const routes = {
    GET_REPORTS: "/reports/:reportClassType/classifications",
    POST_REPORT_POST: "/posts/:postId/report",
    POST_REPORT_COMMENT: "/comments/:commentId/report",
};

export function getReportReasons(
    reportClassType: number,
): Promise<ReportReason[]> {
    return client
        .getData(
            routes.GET_REPORTS.replace(
                ":reportClassType",
                ReportClassType[reportClassType],
            ),
        )
        .then((res) => res.data.items);
}

export function reportPost(
    reportClassId: string,
    postId: number,
): Promise<ReportPayload> {
    return client
        .postData(
            routes.POST_REPORT_POST.replace(":postId", postId.toString()),
            {
                reportClassificationId: parseInt(reportClassId),
            },
        )
        .then((res) => res.data.items);
}

export function postReportComment(
    reportClassId: string,
    commentId: number,
): Promise<PostCommentsInfo> {
    return client
        .postData(
            routes.POST_REPORT_COMMENT.replace(
                ":commentId",
                commentId.toString(),
            ),
            {
                reportClassificationId: parseInt(reportClassId),
            },
        )
        .then((res) => res.data.result);
}
